import t from 'tcomb'

export default t.interface({
	tick: t.Function,
}, 'Compilation')
